<template>
    <div>
        <input
            id="art_code"
            v-model="garniture.set_article"
            v-click-outside="closeAutoComplete"
            type="text"
            class="cabinet-form-group__input"
            autocomplete="off"
            @input="onGarnitureInput"
        />

        <autocomplete
            :is-open="isAutocompleteOpen"
            :suggestions="options"
            key-value="id"
            key-title="set_article"
            @selectSuggestion="onSelectSuggestion"
        />
    </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters, mapActions } from 'vuex'
import ClickOutside from 'vue-click-outside'

import Autocomplete from '@/components/Elements/Autocomplete.vue'
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'GarnitureAutocomplete',
    components: { Autocomplete },
    directives: {
        ClickOutside
    },
    props: {
        productsCount: {
            type: Number,
            default: 1
        },
        brandId: {
            // eslint-disable-next-line
            type: Number | String,
            default: ''
        },
        initialGarniture: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            isAutocompleteOpen: false,
            garniture: {
                id: '',
                set_article: ''
            },
            options: []
        }
    },
    computed: {
        ...mapState('supplierSets', ['sets', 'errors'])
    },
    watch: {
        garniture: {
            handler: function(val) {
                this.$emit('garnitureChange', { ...val })
            },
            deep: true
        }
    },
    mounted() {
        this.garniture = { ...this.initialGarniture }
    },
    methods: {
        ...mapActions('supplierSets', ['getSets']),

        onSelectSuggestion(val) {
            this.garniture = val
        },
        closeAutoComplete() {
            this.isAutocompleteOpen = false
        },
        onGarnitureInput: _.debounce(async function() {
            if (!this.garniture.set_article) return
            this.garniture.id = ''
            await this.getSets({
                BrandID: this.brandId,
                Search: this.garniture.set_article
            })

            this.options = this.sets
                .filter(
                    set =>
                        parseInt(set.set_items_count) + this.productsCount <= 6
                )
                .slice(0, 3)
            this.isAutocompleteOpen = true
        }, 400)
    }
}
</script>
